<template>
	<div style="background-color: white">
		<vs-popup
			:active.sync="showCreateSocietyPopupActive"
			prevent-close
			title="Création d'un nouveau client"
		>
			<SocietyForm
				:ispopup="true"
				button-close-hidden
				@close-popup="closeShowSocietyPopupActive($event)"
			/>
		</vs-popup>
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir supprimer cette mission ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="acceptDeleteMission()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="declineDeleteMission()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-button
			class="float-right m-5"
			radius
			color="primary"
			type="filled"
			icon-pack="feather"
			icon="icon-x"
			@click="returnPrevRoute"
		></vs-button>
		<form-wizard
			style="width: 60vw"
			color="rgba(var(--vs-primary), 1)"
			title="Création d'un contrat"
			subtitle="Ajoutez un contrat et associez lui des prestations"
			nextButtonText="Suivant"
			backButtonText="Retour"
			finishButtonText="Terminer"
		>
			<tab-content
				title="Création du contrat"
				class="mb-5"
				:before-change="saveContract"
			>
				<!-- tab 1 content -->
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2"></div>
				</div>
				<div class="vx-row mt-4">
					<!-- SOCIETY -->
					<div class="vx-col sm:w-1/3 w-full mb-2" style="white-space: nowrap">
						<vx-input-group class="bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									:style="styleValidator('society_id')"
									v-model="contract.society_id"
									class="w-full select-medium mr-2"
									placeholder="Societé"
									@change="validateOne(contract.society_id, 'society_id')"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.name"
										v-for="(item, index) in societyOptions"
										class="w-full"
									/>
								</vs-select>
								<template slot="append">
									<div
										v-if="contract.society_id !== null"
										class="append-text bg-primary"
									>
										<span class="flex"
											><vs-button @click="showSocietyPopup"
												>Détails</vs-button
											></span
										>
									</div>
									<div v-else class="append-text bg-primary">
										<span class="flex"
											><vs-button @click="createSocietyPopup"
												>Créer</vs-button
											></span
										>
									</div>
								</template>
								<vx-tooltip
									v-if="
										validators['society_id'] &&
										validators['society_id'].errText !== ''
									"
									:text="errText('society_id')"
									class="ml-3"
									style="display: inline-block; align-self: self-end"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /SOCIETY -->
					<!-- COMMERCIAL -->
					<div
						class="vx-col sm:w-1/3 w-full mb-2 flex"
						style="white-space: nowrap"
					>
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="person_add" size="small"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									:style="styleValidator('commercial_id')"
									v-model="commercialId"
									class="w-full select-medium mr-2"
									placeholder="Commercial Rankwell"
									@change="validateOne(commercialId, 'commercial_id')"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.firstname + ' ' + item.lastname"
										v-for="(item, index) in commercialOptions"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['commercial_id'] &&
										validators['commercial_id'].errText !== ''
									"
									:text="errText('commercial_id')"
									class="ml-3"
									style="display: inline-block; align-self: self-end"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>

					<!-- /COMMERCIAL -->
					<!-- Fin Programmée -->
					<!-- <div class="vx-col sm:w-1/3 w-full mb-2 flex" style="white-space: nowrap;">
            <vx-input-group class="w-full bottom">
				<template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span class="flex"
                    ><vs-icon icon="calendar_today" size="small"></vs-icon
                  ></span>
                </div>
              </template>
              <flat-pickr
                class="w-full"
                v-model="contract.program_end_date"
                placeholder="Fin Programmée"
              />
            </vx-input-group>
          </div> -->
					<!-- Fin Programmée -->
				</div>
				<div class="vx-row">
					<!-- PRESTATION -->
					<div class="vx-col sm:w-1/4 w-full mb-2" style="white-space: nowrap">
						<label for="" class="vs-select--label"
							>Prestation <span style="color: red">*</span></label
						>
						<div style="display: flex">
							<vs-select
								autocomplete
								:style="styleValidator('delivery')"
								:disabled="missionsAdded > 0"
								v-model="contract.delivery"
								@change="validateOne(contract.delivery, 'delivery')"
								class="w-full select-medium mr-2"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in products_categories"
									class="w-full"
								/>
							</vs-select>
							<vx-tooltip
								v-if="
									validators['delivery'] &&
									validators['delivery'].errText !== ''
								"
								:text="errText('delivery')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<div
						class="vx-col sm:w-1/4 w-full mb-2"
						style="display: inline-table; white-space: nowrap"
					>
						<label for="" class="vs-select--label"
							>Durée d'engagement (mois)</label
						>
						<div style="display: flex">
							<vs-input
								v-model="engagement_duration"
								:style="styleValidator('engagement_duration')"
								@change="
									validateOne(engagement_duration, 'engagement_duration')
								"
							/>
							<vx-tooltip
								v-if="
									validators['engagement_duration'] &&
									validators['engagement_duration'].errText !== ''
								"
								:text="errText('engagement_duration')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<div
						class="vx-col sm:w-1/4 w-full mb-2"
						v-if="engagement_duration > 0"
						style="
							display: inline-table;
							white-space: nowrap;
							align-self: center;
						"
					>
						<vs-checkbox class="inline-flex mt-4" v-model="earlyCancellation">
							<span>Porte de sortie possible</span>
						</vs-checkbox>
					</div>
					<div
						class="vx-col sm:w-1/4 w-full mb-2"
						v-if="earlyCancellation && engagement_duration > 0"
						style="white-space: nowrap"
					>
						<label for="" class="vs-select--label"
							>Durée avant période de sortie</label
						>
						<div style="display: flex">
							<vs-input
								v-model="early_cancellation_duration"
								:style="styleValidator('early_cancellation_duration')"
								@change="
									validateOne(
										early_cancellation_duration,
										'early_cancellation_duration'
									)
								"
							/>
							<vx-tooltip
								v-if="
									validators['early_cancellation_duration'] &&
									validators['early_cancellation_duration'].errText !== ''
								"
								:text="errText('early_cancellation_duration')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- /PRESTATION -->

					<!-- /DATE FIN -->
				</div>
				<div class="vx-row">
					<!-- Facturation -->
					<div class="vx-col sm:w-1/3 w-full mb-2" style="white-space: nowrap">
						<label for="" class="vs-select--label">Facturation</label>
						<div style="display: flex">
							<vs-select
								autocomplete
								v-model="contract.invoice_period"
								class="w-full select-medium mr-2"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in getFacturationOptionList()"
									class="w-full"
								/>
							</vs-select>
							<vx-tooltip
								v-if="
									validators['delivery'] &&
									validators['delivery'].errText !== ''
								"
								:text="errText('delivery')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- Factureation Delay Time -->
					<div class="vx-col sm:w-1/3 w-full mb-2" style="white-space: nowrap">
						<label for="" class="vs-select--label"
							>Délai de paiement des factures</label
						>
						<div style="display: flex">
							<vs-select
								autocomplete
								v-model="contract.invoice_delay_time"
								class="w-full select-medium mr-2"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in getFacturationDelayTime()"
									class="w-full"
								/>
							</vs-select>
							<vx-tooltip
								v-if="
									validators['delivery'] &&
									validators['delivery'].errText !== ''
								"
								:text="errText('delivery')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- Mode de Paiement  -->
					<div class="vx-col sm:w-1/3 w-full mb-2" style="white-space: nowrap">
						<label for="" class="vs-select--label">Mode de Paiement </label>
						<div style="display: flex">
							<vs-select
								autocomplete
								v-model="contract.invoice_type"
								class="w-full select-medium mr-2"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in getFacturationMethod()"
									class="w-full"
								/>
							</vs-select>
							<vx-tooltip
								v-if="
									validators['delivery'] &&
									validators['delivery'].errText !== ''
								"
								:text="errText('delivery')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
				</div>
				<div class="vx-row">
					<!-- COMMENTAIRE DE LA PRESTATION -->
					<div class="vx-col sm:w-full w-full mb-2" style="white-space: nowrap">
						<div style="display: flex">
							<vs-input
								class="w-full"
								label-placeholder="Commentaire"
								v-model="contract.detail"
								:style="styleValidator('detail')"
								@change="validateOne(contract.detail, 'detail')"
							/>
							<vx-tooltip
								v-if="
									validators['detail'] && validators['detail'].errText !== ''
								"
								:text="errText('detail')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- /COMMENTAIRE DE LA PRESTATION -->
				</div>
				<div class="vx-row">
					<!-- COMMENTAIRE FACTURATION -->
					<div class="vx-col sm:w-full w-full mb-2" style="white-space: nowrap">
						<div style="display: flex">
							<vs-input
								class="w-full"
								label-placeholder="Commentaire facturation"
								v-model="contract.commentary"
								:style="styleValidator('commentary')"
								@change="validateOne(contract.commentary, 'commentary')"
							/>
							<vx-tooltip
								v-if="
									validators['commentary'] &&
									validators['commentary'].errText !== ''
								"
								:text="errText('commentary')"
								class="ml-3"
								style="display: inline-block; align-self: self-end"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</div>
					</div>
					<!-- /COMMENTAIRE FACTURATION -->
				</div>

				<div class="vx-row w-full" style="margin-bottom: 20px">
					<div class="vx-col w-full" style="margin-top: 20px">
						<div class="vx-row w-full" style="padding-left: 15px">
							<span class="title w-full">Documents du contrat</span>
						</div>
						<div
							class="vx-row w-full"
							style="justify-content: start; margin-top: 10px"
						>
							<div class="vx-col sm:w-1/4 flex">
								<vs-input
									class="inputx w-full"
									placeholder="Lien vers le document"
									v-model="addDocLink"
									:style="styleValidator('docLink')"
									@change="validateOne(addDocLink, 'docLink')"
								/>
								<vx-tooltip
									v-if="
										validators['docLink'] &&
										validators['docLink'].errText !== ''
									"
									:text="errText('docLink')"
									class="ml-3"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<div class="sm:w-1/4 vx-col">
								<vs-select
									v-model="addDocType"
									class="select-medium mr-2"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.type_name"
										v-for="(item, index) in typeList"
										class="w-full"
									/>
								</vs-select>
							</div>
							<div class="vx-col sm:w-1/4 flex">
								<vs-input
									class="inputx"
									placeholder="Nom du document"
									v-model="addDocName"
									:style="styleValidator('docName')"
									@change="validateOne(addDocName, 'docName')"
								/>
								<vx-tooltip
									v-if="
										validators['docName'] &&
										validators['docName'].errText !== ''
									"
									:text="errText('docName')"
									class="ml-3"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
							<div class="vx-col">
								<vs-button color="primary" @click="validateAll()">
									Ajouter
								</vs-button>
							</div>
						</div>
						<ContractDocumentsForContractTable
							ref="documents"
							:contract_documents="allContractDocuments"
							:typeList="typeList"
						/>
					</div>
				</div>
				<div class="vx-column w-1/3 t-border mt-4">
					<label for="" class="vs-select--label"
						>Sélectionnez un Consultant</label
					>
					<vx-input-group>
						<!-- <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span class="flex"
                    ><vs-icon icon="person_add" size="small"></vs-icon
                  ></span>
                </div>
              </template> -->
						<vs-select
							v-model="selectedAccountManager"
							class="w-full select-medium mr-2"
							placeholder="Consultant Lead"
							autocomplete
						>
							<vs-select-item
								:key="index"
								:value="item"
								:text="item.firstname + ' ' + item.lastname"
								v-for="(item, index) in accountmanagerOptions"
								class="w-full"
							/>
						</vs-select>
						<!-- <vs-button class="mt-2" @click="addAccountManager(selectedAccountManager)">Ajouter</vs-button> -->
					</vx-input-group>
					<vs-table
						:data="accountmanagerList"
						v-if="accountmanagerList"
						class="mt-3"
						style="overflow: hidden"
						v-model="lead_account_manager"
						noDataText="Aucun(e) Consultant Lead sélectionné(e)."
						:key="refreshList"
					>
						<template slot="thead">
							<vs-th>Consultant Lead</vs-th>
							<!-- Madame ou Monsieur -->
							<vs-th></vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr
								:data="data[indextr]"
								:key="indextr"
								v-for="(tr, indextr) in data"
							>
								<vs-td>{{
									data[indextr].firstname + " " + data[indextr].lastname
								}}</vs-td>
								<!-- Madame ou Monsieur -->
								<!--<vs-td v-if="lead_account_manager == data[indextr]"><vs-button @click="deleteAccountManagerLead(data[indextr].id)" class="mx-2">Supprimer</vs-button><span>Lead</span></vs-td>-->
								<vs-td
									><vs-button @click="deleteAccountManager(data[indextr].id)"
										>Supprimer</vs-button
									></vs-td
								>
							</vs-tr>
						</template>
					</vs-table>
					<!-- </div>
          <div class="vx-row center_div t-border"> -->
					<!-- ACCOUNT MANAGER -->
					<div class="vx-column w-1/3 t-border mt-4"></div>
					<!-- /ACCOUNT MANAGER -->
				</div>
			</tab-content>
			<!-- tab 2 content -->
			<tab-content title="Ajout des prestations" class="mb-5">
				<div class="vx-col" v-if="contractMissions && !clickAddMission">
					<div class="vx-row center_div">
						<vs-table
							:data="contractMissions"
							class="table_sizing"
							noDataText="Aucune prestation."
						>
							<template slot="thead">
								<vs-th>Prestation(s)</vs-th>
								<vs-th>Commentaire</vs-th>
								<vs-th>Récurrence</vs-th>
								<vs-th>Tarif</vs-th>
								<vs-th>Temps maximum</vs-th>
								<vs-th>Prix Collaborateur Externe</vs-th>
								<vs-th>Nombre de points</vs-th>
								<!--<vs-th>Budget Max</vs-th>-->
								<vs-th></vs-th>
								<vs-th></vs-th>
								<vs-th></vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>{{ getProductName(data[indextr].products_id) }}</vs-td>
									<vs-td>{{ data[indextr].commentary }}</vs-td>
									<vs-td v-if="data[indextr].recurrence">{{
										getContractFrequency(data[indextr].frequency)
									}}</vs-td>
									<vs-td v-else>{{
										getContractRecurrence(data[indextr].recurrence)
									}}</vs-td>
									<vs-td>{{ data[indextr].price }} €</vs-td>
									<vs-td>{{ data[indextr].time_limit }}h</vs-td>
									<vs-td>{{ data[indextr].provider_price_text }}</vs-td>
									<vs-td>{{ data[indextr].meeting_number }}</vs-td>
									<!--<vs-td>{{ data[indextr].max_budget }}</vs-td>-->
									<vs-td>
										<div class="flex center">
											<vs-chip
												style="width: 80px"
												:color="getContractStatusColor(data[indextr].status)"
											>
												{{ getContractStatus(data[indextr].status) }}
											</vs-chip>
										</div>
									</vs-td>
									<vs-td>
										<vx-tooltip text="Modifier" position="top">
											<vs-button
												size="large"
												color="primary"
												type="flat"
												icon-pack="feather"
												icon="icon-edit-2"
												@click="updateMission(tr)"
											></vs-button>
										</vx-tooltip>
									</vs-td>
									<vs-td v-if="$acl.check('sadmin')">
										<vx-tooltip text="Effacer" position="top">
											<vs-button
												size="large"
												color="danger"
												type="flat"
												icon-pack="feather"
												icon="icon-trash-2"
												@click="showDeletePopup(tr.id)"
											></vs-button>
										</vx-tooltip>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
				<div class="vx-col mt-4">
					<div class="vx-row center_div">
						<vs-button
							type="filled"
							@click="displayMissionForContract(false)"
							v-if="!clickAddMission"
							>Ajouter une prestation</vs-button
						>
					</div>
					<div ref="popupContainer">
						<!-- GENERER DYNAMIQUEMENT -->
					</div>
				</div>
			</tab-content>

			<!-- CONTROL UI FOOTER BUTTON -->
			<template slot="footer" slot-scope="props">
				<div class="wizard-footer-left">
					<wizard-button
						v-if="props.activeTabIndex > 0 && !props.isLastStep"
						@click.native="props.prevTab()"
						:style="props.fillButtonStyle"
						>Previous</wizard-button
					>
				</div>
				<div class="wizard-footer-right">
					<wizard-button
						v-if="!props.isLastStep"
						@click.native="props.nextTab()"
						class="wizard-footer-right"
						:style="props.fillButtonStyle"
						>Suivant</wizard-button
					>

					<wizard-button
						v-else-if="!clickAddMission"
						@click.native="returnPrevRoute"
						class="wizard-footer-right finish-button"
						:style="props.fillButtonStyle"
						>{{ props.isLastStep ? "Terminer" : "Next" }}
					</wizard-button>
				</div>
			</template>
		</form-wizard>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import Validator from "@/entities/Validator";
import utilsMixin from "@/mixins/utilsMixin";
import validatorMixin from "@/mixins/validatorMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import store from "@/store/store";
import Contract from "@/entities/Contract";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import Mission from "@/entities/Mission";
//import Societies from "@/components/forms/society/Society.vue";
import MissionForContract from "../mission/MissionForContract";
import ContractSocietyInfoPopup from "@/components/popups/ContractSocietyInfoPopup";
import ContractDocumentsForContractTable from "@/components/tables/ContractDocumentsForContractTable";
import SocietyForm from "@/components/forms/society/Society";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import vueFilePond from "vue-filepond";
// Import Filepond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";

// Import Filepond styles
import "filepond/dist/filepond.min.css";
// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
	name: "ContractForm",
	mixins: [utilsMixin, dbFieldConvertor, validatorMixin],
	components: {
		ContractDocumentsForContractTable,
		FormWizard,
		TabContent,
		WizardButton,
		SocietyForm,
		VxTooltip,
		flatPickr,
	},
	data() {
		return {
			currentStepIndex: 0,
			contractMissions: [],
			missionsAdded: 0,
			clickAddMission: false,
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			commercialOptions: [],
			accountmanagerOptions: [],
			contractOptions: [
				{ text: "Mensuel", value: 1 },
				{ text: "One Shot", value: 0 },
			],
			// DATE PICKER CONFIG
			configFromDatePicker: {
				minDate: new Date(),
			},
			// Validator Objects
			ContractValidationObjects: {
				bccgvValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: false,
				},
				estimateLinkValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: false,
				},
			},
			// FORM FIELDS
			contract: Contract.getFormFields(),
			commercialId: null,
			selectedAccountManager: null,
			accountmanagerList: [],
			productOptions: [],
			lead_account_manager: [],
			contractIsAdded: false,
			selectedSociety: null,
			showSocietyPopupActive: false,
			showCreateSocietyPopupActive: false,
			showValidationPopup: false,
			missionToDelete: null,
			bccgvToUpdate: null,
			tempSocietyId: null,
			validators: [],
			check: true,
			checkPage: false,
			earlyCancellation: false,
			early_cancellation_duration: null,
			engagement_duration: null,
			refreshList: 0,
			// DOCUMENTS
			allContractDocuments: [],
			typeList: [],
			addDocName: null,
			addDocLink: null,
			addDocType: 1,
			addDocId: 0,
		};
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},

	computed: {
		societyOptions() {
			//.unshift({"name": "Ajoute Nouveau Client"}).unshift({"name": "Ajoute Nouveau Client"})
			return store.state.societiesOption;
		},
		products_categories: () => {
			return store.state.products_categories;
		},
		activeUser() {
			return VueCookies.get("userInfo");
		},
	},
	watch: {
		selectedAccountManager: function (data) {
			if (data) {
				this.addAccountManager(data);
			}
		},
		societyOptions: function () {
			if (this.tempSocietyId) {
				this.contract.society_id = this.tempSocietyId;
				this.tempSocietyId = null;
			}
		},
		/**
		 * Once the user add a mission
		 * Refresh data by getting all the missions for the current contract
		 */
		missionsAdded: function () {
			this.getContractMission(this.contract.id);
		},
	},

	created() {
		this.getAllSocieties();
		this.getAllCommercials();
		this.getAllAccountManagers();
		this.getAllProducts();
		this.getAllType();
		this.getAllProductsCategories();
		let today = new Date(Date.now());
		this.contract.startDate = today.toISOString();
	},
	methods: {
		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},

		getAllType() {
			this.$http
				.get(this.apiUrl + "contracts_documents/list/doctype/all")
				.then((result) => {
					this.typeList = result.data;
				});
		},
		/**
		 * Query our API to fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocietiesIdAndName");
		},

		/**
		 * Query our API to fetch all the commercials
		 */
		getAllCommercials() {
			this.$http
				.get(this.apiUrl + "users/all/rankwell")
				.then((res) => {
					this.commercialOptions = this.sortABC(
						res.data
							.filter((collaborator) => [4, 6, 9].includes(collaborator.type))
							.filter((collaborator) => collaborator.status == 1),
						"firstname"
					);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Query our API to fetch all the account managers
		 */
		getAllAccountManagers() {
			this.$http
				.get(this.apiUrl + "users/all/accountmanager")
				.then((res) => {
					this.accountmanagerOptions = res.data.filter(
						(collaborator) => collaborator.status == 1
					);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Query our API to fetch all products
		 */
		getAllProducts() {
			this.$http
				.get(this.apiUrl + "product/all/")
				.then((res) => {
					this.productOptions = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Returns product's name from product's id
		 */
		getProductName(product_id) {
			let product_name = "";
			let product_name_object = this.productOptions.find(
				(product) => product.id == product_id
			);
			product_name = product_name_object.perform;
			return product_name;
		},

		/**
		 * Query our api to fetch all the mission linked to a contract
		 */
		getContractMission(contractId) {
			this.$http
				.get(this.apiUrl + "mission/get/contract/" + contractId)
				.then((res) => {
					this.contractMissions = res.data;
					this.missionsAdded = this.contractMissions.length;
					//console.log("this.contractMissions");
					//console.log(res.data);
				})
				.catch((err) => {
					console.error("getContractMission error");
					console.error(err);
				});
		},

		/**
		 * Création et affichage du popup de création de mission
		 */
		displayMissionForContract(isEdit, mission = null) {
			//Initialisation des données pour le popup
			if (mission !== null) {
				let re = new RegExp("([T|Z])", "g");
				if (mission.start_date)
					mission.start_date = mission.start_date.replace(re, " ");
				if (mission.end_date)
					mission.end_date = mission.end_date.replace(re, " ");
			}
			this.clickAddMission = true;
			let propsData = isEdit
				? {
						propsData: {
							contract: this.contract,
							missionToModify: mission,
							show: this.clickAddMission,
							apiUrl: this.apiUrl,
							router: this.$router,
							editMode: isEdit,
						},
				  }
				: {
						propsData: {
							contract: this.contract,
							show: this.clickAddMission,
							apiUrl: this.apiUrl,
							router: this.$router,
							editMode: isEdit,
						},
				  };

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(MissionForContract);
			let missionPopup = new ComponentClass(propsData);
			missionPopup.$mount();
			missionPopup.$on("close-form", () => {
				this.closeMissionForm();
			});
			missionPopup.$on("close-form-after-added", (event) => {
				this.refreshData(event);
			});
			this.$refs.popupContainer.appendChild(missionPopup.$el);
		},
		updateMission(mission) {
			this.displayMissionForContract(true, mission);
			//console.log("mission", mission);
			//console.log("updateMission called");
		},

		deleteMission(missionId) {
			//console.log("missionId", missionId);
			//console.log("deleteMission called");
			Mission.delete(missionId, this.activeUser.id, (err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						//console.log(res);
						this.missionsAdded -= 1;
					}
			});
		},

		showDeletePopup(missionId) {
			this.missionToDelete = missionId;
			this.showValidationPopup = true;
		},

		acceptDeleteMission() {
			this.deleteMission(this.missionToDelete);
			this.showValidationPopup = false;
		},

		declineDeleteMission() {
			this.missionToDelete = null;
			this.showValidationPopup = false;
		},

		validateOne(val, name) {
			if (val == 9999999999 && name == "society_id") {
				this.contract.society_id = "";
				this.createSocietyPopup();
			} else {
				let value = val;
				value == 0 ? (value = "0") : "";
				let constname = "";
				switch (name) {
					case "docName":
						constname = "rnameConstraint";
						break;
					case "docLink":
						constname = "linkConstraint";
						break;
					case "society_id":
						this.selectedSociety = this.contract.societyId;

						this.$http
							.get(this.apiUrl + "society/get/" + this.contract.society_id)
							.then((res) => {
								this.commercialId = res.data.commercial_id;
							});
						break;
					case "early_cancellation_duration":
					case "engagement_duration":
					case "delivery":
					case "commercial_id":
						value ? (value = String(val)) : "";
						value == null ? (value = "") : "";
						constname = "isNumberConstraint";
						break;
					case "commentary":
					case "detail":
						constname = "commentaryConstraint";
						break;
					default:
						break;
				}
				this.validators[name] = new Validator({ constraintName: constname });
				this.validators[name].check(value);
				if (
					this.validators[name].valid == false &&
					this.validators[name].errText == ""
				) {
					if (
						name == "society_id" ||
						name == "commercial_id" ||
						name == "delivery"
					) {
						this.validators[name].errText = "Ce champ ne peut être vide.";
					} else if (
						this.earlyCancellation &&
						name == "early_cancellation_duration"
					) {
						this.validators[name].errText = "Ce champ ne peut être vide.";
					}
				}
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
					? (this.check = false)
					: "";
				if (
					this.earlyCancellation &&
					name == "early_cancellation_duration" &&
					this.early_cancellation_duration <= 0
				) {
					this.validators[name].errText = "Ce champ doit être supérieur à 0.";
				}
				this.$forceUpdate();
			}
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				switch (name) {
					case "society_id":
						return "border: 1px solid red !important;";
					case "commercial_id":
						return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid red !important; border-radius: 5px;";
				}
			} else if (this.validators[name] && this.validators[name].errText == "") {
				switch (name) {
					case "society_id":
						return "border: 1px solid green !important;";
					case "commercial_id":
						return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid green !important; border-radius: 5px;";
				}
			} else {
				return "border: none !important; border-radius: none;";
			}
		},

		validateAll() {
			this.check = true;
			let fields = ["docName", "docLink"];
			for (let i = 0; i < fields.length; i++) {
				let name = "";
				let value = "";
				if (fields[i] == "docName") {
					name = "rnameConstraint";
					value = this.addDocName;
				} else {
					name = "linkConstraint";
					value = this.addDocLink;
				}
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				this.validators[fields[i]].errText == "" &&
				this.validators[fields[i]].valid == false
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				this.validators[fields[i]].valid == false ? (this.check = false) : "";
				this.$forceUpdate();
			}
			if (this.check) {
				this.addDocId++;
				this.allContractDocuments.push({
					id: this.addDocId,
					filename: this.addDocName,
					link: this.addDocLink,
					contract_document_type_id: this.addDocType,
				});
			}
		},

		/**
		 * Send the data to tha API to create the new society
		 * If the form is successfully sent, the society is redirect to Client.vue
		 */
		saveContract() {
			let returnBool = true;

			this.check = true;
			this.checkPage = false;
			let fields = [
				"society_id",
				"commercial_id",
				"delivery",
				"commentary",
				"detail",
				"early_cancellation_duration",
				"engagement_duration",
			];
			for (let i = 0; i < fields.length; i++) {
				let name = "";
				let value = "";
				switch (fields[i]) {
					case "commercial_id":
						value = this.commercialId;
						break;
					case "early_cancellation_duration":
						value = this.early_cancellation_duration;
						break;
					case "engagement_duration":
						value = this.engagement_duration;
						break;
					/*
					 * case "max_budget":
					 * value ? value = String(value) : "";
					 * name = "priceConstraint";
					 * break;
					 */
					default:
						value = this.contract[fields[i]];
				}
				value == 0 ? (value = "0") : "";
				switch (fields[i]) {
					case "society_id":
					case "early_cancellation_duration":
					case "engagement_duration":
					case "commercial_id":
						value ? (value = String(value)) : "";
						value == null ? (value = "") : "";
						name = "isNumberConstraint";
						break;
					case "commentary":
					case "detail":
						name = "commentaryConstraint";
						break;
					default:
						break;
				}
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				) {
					if (fields[i] == "society_id" || fields[i] == "commercial_id") {
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					} else if (
						this.earlyCancellation &&
						fields[i] == "early_cancellation_duration"
					) {
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					}
				}
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
				if (
					this.earlyCancellation &&
					fields[i] == "early_cancellation_duration" &&
					this.early_cancellation_duration <= 0
				) {
					this.validators[fields[i]].errText =
						"Ce champ doit être supérieur à 0.";
					this.check = false;
				}
				this.$forceUpdate();
			}
			if (this.contract.delivery == null || this.contract.delivery == "") {
				this.check = false;
			}
			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.checkPage = true;
				if (this.accountmanagerList.length > 0) {
					this.accountmanagerList[0].is_lead = 1;
				}
				if (this.contractIsAdded == true) {
					let formatedDate;
					if (this.contract.start_date == undefined) {
						//console.log("undefined start_date");
						let today = new Date(Date.now());
						formatedDate = today.toISOString();
						formatedDate = this.formatedDate.substring(0, 10);
						formatedDate = formatedDate + " 02:00:00";
						//console.log("undefined start_date", formatedDate);
					} else {
						formatedDate = this.contract.start_date.substring(0, 10);
						formatedDate = formatedDate + " 02:00:00";
						//console.log("defined start_date", formatedDate);
					}
					let updateToContract = {
						id: this.contract.id,
						type: this.contract.type,
						creation_date: this.contract.creation_date.replace(/T|Z/g, " "),
						start_date: formatedDate,
						endDate: this.contract.endDate,
						commentary: this.contract.commentary,
						detail: this.contract.detail,
						delivery: this.contract.delivery,
						estimate_link: this.contract.estimateLink,
						bccgv_link: this.contract.bccgv_link,
						society_id: this.contract.society_id,
						status: this.contract.status,
						commercial_id: this.commercialId,
						account_managers: this.accountmanagerList,
						max_budget: 0,
						users_id: this.activeUser.id,
						early_cancellation: this.earlyCancellation,
						invoice_period: this.invoice_period,
						invoice_delay_time: this.invoice_delay_time,
						invoice_type: this.invoice_type,
						early_cancellation_duration: this.early_cancellation_duration,
						engagement_duration: this.engagement_duration,
						termination_reason_id: 0,
						program_end_date: this.contract.program_end_date
							? this.contract.program_end_date + " 02:00:00"
							: null,
					};
					this.$http
						.post(this.apiUrl + "contract/edit", updateToContract)
						.then((res) => {
							if (this.allContractDocuments.length > 0) {
								let tmp = [...this.$refs.documents.docList];
								let list = [];
								for (let doc of tmp) {
									list.push([
										doc.link,
										doc.filename,
										res.data[0].id,
										this.activeUser.id,
										doc.contract_document_type_id,
									]);
								}
								this.allContractDocuments = tmp;
								this.$http
									.post(this.apiUrl + "contracts_documents/editAll", {
										list: list,
										id: this.contract.id,
									})
									.then(() => {
										//console.log("Update documents: OK.");
									});
							}

							if (this.bccgvToUpdate) {
								this.$http
									.post(
										this.apiUrl + "contract/updateBccgv/" + res.data[0].id,
										this.bccgvToUpdate,
										{
											headers: {
												accept: "application/json",
												"Accept-Language": "en-US,en;q=0.8",
												"Content-Type": `multipart/form-data; boundary=${this.bccgvToUpdate._boundary}`,
											},
										}
									)
									.then(() => {
										this.$vs.notify({
											title: "Succès",
											text: "BCCGV uploadé avec succès.",
										});
										this.contract = res.data[0];
										//console.log("res.data[0]");
										//console.log(res.data[0]);
										this.getContractMission(this.contract.id);
										// Send a success notification to the user
										this.$vs.notify({
											title: "Succès",
											text: "Contrat modifié avec succès.",
										});
										returnBool = true; // So that it goes to the next tab-content
									})
									.catch((err) => {
										//console.log(err);
										this.$vs.notify({
											title: "Echec",
											text: "L'upload des BCCGV a échoué.",
										});
									});
							} else {
								this.contract = res.data[0];
								//console.log("res.data[0]");
								//console.log(res.data[0]);
								this.getContractMission(this.contract.id);
								// Send a success notification to the user
								this.$vs.notify({
									title: "Succès",
									text: "Contrat modifié avec succès.",
								});
								returnBool = true; // So that it goes to the next tab-content
							}
							this.contract = updateToContract;
						})
						.catch((err) => {
							console.error("err");
							console.error(err);
							this.$vs.notify({
								title: "Echec",
								text: "Le contrat n'a pas été modifié.",
							});
							returnBool = false;
						});
				} else {
					this.$http
						.post(this.apiUrl + "contract/new", {
							endDate: this.contract.endDate,
							commentary: this.contract.commentary,
							detail: this.contract.detail,
							delivery: this.contract.delivery,
							estimate_link: this.contract.estimateLink,
							bccgv_link: this.contract.bccgv_link,
							society_id: this.contract.society_id,
							commercial_id: this.commercialId,
							account_managers: this.accountmanagerList,
							max_budget: 0,
							users_id: this.activeUser.id,
							early_cancellation: this.earlyCancellation,
							early_cancellation_duration: this.early_cancellation_duration,
							engagement_duration: this.engagement_duration,
							invoice_period: this.invoice_period,
							invoice_delay_time: this.invoice_delay_time,
							invoice_type: this.invoice_type,
							creation_date:
								new Date().toISOString().substr(0, 10) + " 02:00:00",
							program_end_date: this.contract.program_end_date
								? this.contract.program_end_date + " 02:00:00"
								: null,
						})
						.then((res) => {
							if (this.allContractDocuments.length > 0) {
								let tmp = [...this.$refs.documents.docList];
								let list = [];
								for (let doc of tmp) {
									list.push([
										doc.link,
										doc.filename,
										res.data[0].id,
										this.activeUser.id,
										doc.contract_document_type_id,
									]);
								}
								this.allContractDocuments = tmp;
								//console.log("this.allContractDocuments", this.allContractDocuments);
								this.$http
									.post(this.apiUrl + "contracts_documents/addAll", {
										list: list,
									})
									.then(() => {
										//console.log("Ajout des documents: OK.");
									});
							}
							if (this.bccgvToUpdate) {
								this.$http
									.post(
										this.apiUrl + "contract/updateBccgv/" + res.data[0].id,
										this.bccgvToUpdate,
										{
											headers: {
												accept: "application/json",
												"Accept-Language": "en-US,en;q=0.8",
												"Content-Type": `multipart/form-data; boundary=${this.bccgvToUpdate._boundary}`,
											},
										}
									)
									.then(() => {
										//////////////
										let user_name =
											this.activeUser.firstname +
											" " +
											this.activeUser.lastname;
										//console.log(user_name);
										this.contractIsAdded = true;
										this.contract = res.data[0];
										//console.log("res.data[0]");
										//console.log(res.data[0]);
										this.getContractMission(this.contract.id);
										let society_name = this.societyOptions.find(
											(society) => society.id == this.contract.society_id
										).name;
										this.$http
											.post(this.apiUrl + "mail/newcontract", {
												contract: this.contract.id,
												society: society_name,
												user: user_name,
											})
											.then((res2) => {
												/////////////////
												// Send a success notification to the user
												this.$vs.notify({
													title: "Succès",
													text: "Contrat ajouté avec succès.",
												});
												returnBool = true; // So that it goes to the next tab-content
												/////////////////
											})
											.catch((err) => {
												console.error("err");
												console.error(err);
												this.$vs.notify({
													title: "Echec",
													text: "Le contrat n'a pas été ajouté.",
												});
												returnBool = false;
											});
									})
									.catch((err) => {
										console.error(err);
										this.$vs.notify({
											title: "Echec",
											text: "Le contrat n'a pas été ajouté.",
										});
										returnBool = false;
									});
							} else {
								//////////////
								let user_name =
									this.activeUser.firstname + " " + this.activeUser.lastname;
								//console.log(user_name);
								this.contractIsAdded = true;
								this.contract = res.data[0];
								//console.log("res.data[0]");
								//console.log(res.data[0]);
								this.getContractMission(this.contract.id);
								let society_name = this.societyOptions.find(
									(society) => society.id == this.contract.society_id
								).name;
								this.$http
									.post(this.apiUrl + "mail/newcontract", {
										contract: this.contract.id,
										society: society_name,
										user: user_name,
									})
									.then((res2) => {
										/////////////////
										// Send a success notification to the user
										this.$vs.notify({
											title: "Succès",
											text: "Contrat ajouté avec succès.",
										});
										returnBool = true; // So that it goes to the next tab-content
										/////////////////
									})
									.catch((err) => {
										console.error("err");
										console.error(err);
										this.$vs.notify({
											title: "Echec",
											text: "Le contrat n'a pas été ajouté.",
										});
										returnBool = false;
									});
							}
						})
						.catch((err) => {
							console.error("err");
							console.error(err);
							this.$vs.notify({
								title: "Echec",
								text: "Le contrat n'a pas été ajouté.",
							});
							returnBool = false;
						});
				}
				return returnBool;
			}
		},

		showMissionForm() {
			this.clickAddMission = true;
		},

		closeMissionForm(value) {
			this.clickAddMission = value;
		},

		/**
		 * Checks if estimate link is valid
		 */
		checkEstimateLink() {
			this.checkHandler(
				this.contract.estimateLink,
				this.ContractValidationObjects.estimateLinkValidationObject
			);
		},

		/**
		 * Checks if bccgv link is valid
		 */
		checkBcCgv() {
			this.checkHandler(
				this.contract.bccgv_link,
				this.ContractValidationObjects.bccgvValidationObject
			);
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllRequiredFields() {
			let requiredFieldsOk = true;

			Object.entries(this.ContractValidationObjects).forEach((entry) => {
				const [key, value] = entry;
				if (value.required && !value.valid && requiredFieldsOk) {
					requiredFieldsOk = value.valid;
				}
			});

			return requiredFieldsOk;
		},

		refreshData(value) {
			this.getAllProducts();
			this.missionsAdded += value;
			this.clickAddMission = false; // Close the form
		},

		addAccountManager(selectedAccountManager) {
			this.accountmanagerList = [];
			if (selectedAccountManager && this.accountmanagerList.length < 1) {
				let selectedAccountManagerIsPresent = this.accountmanagerList.filter(
					(accountManager) => accountManager.id == selectedAccountManager.id
				);
				if (selectedAccountManagerIsPresent.length <= 0) {
					this.lead_account_manager = selectedAccountManager;
					this.accountmanagerList.push(selectedAccountManager);
				}
			}
		},
		deleteAccountManager(selectedAccountManager) {
			this.accountmanagerList = [];
		},
		deleteAccountManagerLead(selectedAccountManager) {
			//console.log("deleteAccountManagerLead");
			this.accountmanagerList = [];
			this.refreshList++;
		},

		closeShowSocietyPopupActive(societyId) {
			//console.log("CLOSE POPUP ");
			//console.log(societyId);
			if (societyId) {
				//RELOAD SOCIETIES
				this.getAllSocieties();
				//SELECT SOCIETY
				this.tempSocietyId = societyId;
			}
			this.showCreateSocietyPopupActive = false;
		},

		createSocietyPopup() {
			this.showCreateSocietyPopupActive = true;
		},

		showSocietyPopup() {
			//Initialisation des données pour le popup
			this.selectedSociety = null;
			this.selectedSociety = this.societyOptions.find(
				(society) => society.id == this.contract.society_id
			);
			this.showSocietyPopupActive = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractSocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopupActive,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
			//console.log("showSocietyPopup");
		},

		addBccgvToPost() {
			let bccgv = this.$refs.bccgvUp.getFile();
			let formData = new FormData();
			formData.append("bccgv", bccgv.file);
			this.bccgvToUpdate = formData;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			if (this.missionsAdded == 0 && this.checkPage == true) {
				this.$vs.notify({
					title: "Echec",
					text: "Vous devez ajouter au moins une prestation.",
				});
				return false;
			}
			this.$router.go(-1);
		},
	},
};
</script>

<style>
.wizard-nav li {
	pointer-events: none;
}

.center_div {
	justify-content: center;
}
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.table_sizing {
	max-width: 800px;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}
</style>
